module.exports = __webpack_public_path__ + "static/media/ticklock.c7c440ea.svg";